import React, { Component, Fragment } from "react";
import AppContext from "../../contexts/AppContext";
import { Link } from "react-router-dom";
import Header from "./Header";
import { records } from "../../services/employerJobListing";
import Posts from "../blog/Posts";
class Dashboard extends Component {
    state = {
        items: []
    };
    componentDidMount() {
        records(1)
            .then(response => {
                this.setState({
                    items: response.data,
                    meta: response.meta
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }
    render() {
        return (
            <Fragment>
                <Header></Header>
                <div className="main-content mt-5">
                    <div className="container pt-6">
                        <div className="row">
                            <div className="col-xl-8 col-md-8">
                                <div className="card text-left">
                                    <div className="card-header">
                                        <h4 className="card-header-title">
                                            My Open Job Listings
                                        </h4>
                                    </div>
                                    <div className="table-responsive mb-0">
                                        <table className="table table-sm table-nowrap card-table">
                                            <thead>
                                                <tr>
                                                    <th>Job Title</th>
                                                    <th>Applicants</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.items.length >=
                                                1 ? (
                                                    this.state.items.map(
                                                        (item, index) => {
                                                            return (
                                                                <tr>
                                                                    <td>
                                                                        {
                                                                            item.title
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            item.applicants
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }
                                                    )
                                                ) : (
                                                    <td
                                                        colSpan="2"
                                                        className="text-center"
                                                    >
                                                        <h5 className="text-muted mt-3 mb-3">
                                                            No jobs to display
                                                        </h5>
                                                        <Link
                                                            to={`/employer/jobListing/create`}
                                                            className="btn btn-primary px-5 mb-4"
                                                        >
                                                            Post a job
                                                        </Link>
                                                    </td>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="card text-left">
                                    <div className="card-header">
                                        {/* Title */}
                                        <h4 className="card-header-title">
                                            My Open Jobs
                                        </h4>
                                    </div>
                                    <div className="table-responsive mb-0">
                                        <table className="table table-sm table-nowrap card-table">
                                            <thead>
                                                <tr>
                                                    <th>Job Title</th>
                                                    <th>Applicants</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.items.length >=
                                                1 ? (
                                                    this.state.items.map(
                                                        (item, index) => {
                                                            return (
                                                                <tr>
                                                                    <td>
                                                                        {
                                                                            item.title
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            item.applicants
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }
                                                    )
                                                ) : (
                                                    <td
                                                        colSpan="2"
                                                        className="text-center"
                                                    >
                                                        <h5 className="text-muted mt-3 mb-3">
                                                            No jobs to display
                                                        </h5>
                                                        <Link
                                                            to={`/employer/jobListing/create`}
                                                            className="btn btn-primary px-5 mb-4"
                                                        >
                                                            Post a job
                                                        </Link>
                                                    </td>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-md-4">
                                <Posts></Posts>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
Dashboard.contextType = AppContext;
export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/employer/Dashboard.js